import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-basis-modal__container" }
const _hoisted_2 = { class: "base-info__container" }
const _hoisted_3 = { class: "base-info__item" }
const _hoisted_4 = { class: "base-info__item--label" }
const _hoisted_5 = { class: "base-info__item--value" }
const _hoisted_6 = { class: "base-info__item" }
const _hoisted_7 = { class: "base-info__item--label" }
const _hoisted_8 = { class: "base-info__item--value" }
const _hoisted_9 = { class: "base-info__item" }
const _hoisted_10 = { class: "base-info__item--label" }
const _hoisted_11 = { class: "base-info__item--value" }
const _hoisted_12 = { class: "base-info__item" }
const _hoisted_13 = { class: "base-info__item--label" }
const _hoisted_14 = { class: "base-info__item--value" }
const _hoisted_15 = { class: "base-info__item" }
const _hoisted_16 = { class: "base-info__item--label" }
const _hoisted_17 = { class: "base-info__item--value" }
const _hoisted_18 = { class: "base-info__item" }
const _hoisted_19 = { class: "base-info__item--label" }
const _hoisted_20 = { class: "base-info__item--value" }

import { diContainer } from '@/coreContainer/container';
import { Order } from '@/coreDomainsModule/entities/order';
import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';
import { convertLeadTimeByUnit } from '@/coreDomainsModule/leadtime';
import { DateService } from '@/coreDomainsModule/services/dateService';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { i18n } from '@/i18n';
import { computed, ref, watchEffect } from 'vue';
import OrderBasisDetailSection from './OrderBasisDetailSection.vue';

interface Props {
  modalState?: boolean;
  orderData?: Order;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderBasisInfoModal',
  props: {
    modalState: { type: Boolean, default: false },
    orderData: { default: undefined }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

/**
 * コンポーネントのProps定義
 */
const props = __props;

const emits = __emit;

const basisData = ref<IOrderBasis | undefined>(undefined);

const sourceOrderInfo = computed(() => basisData.value?.sourceOrderInfos.find((info) => info.sourceOrderId === props.orderData?.orderId));

/**
 * エラーモーダルを表示する
 */
const showErrorModal = async () => {
  await showInfoModal({
    modalTitle: t('エラーが発生しました。'),
    modalDescription: t('発注根拠の取得に失敗しました。'),
    isDisabledNextButton: true,
    backButtonLabel: t('OK'),
    colorStyle: 'error',
    icon: 'error',
  });
  closeModal();
};

/**
 * このモーダルを閉じる
 */
const closeModal = () => {
  emits('close');
};

watchEffect(async () => {
  // データがない場合はスキップ
  if (!props.modalState || !props.orderData) {
    basisData.value = undefined;
    return;
  }
  const orderBasisId = props.orderData.orderBasisId;
  if (!orderBasisId) {
    await showErrorModal();
    return;
  }
  // 発注根拠情報取得
  const result = await waitLoading(diContainer.getOrderBasisUseCase.execute(orderBasisId));
  if (!result || result.status.type === 'error') {
    await showErrorModal();
    return;
  }
  basisData.value = result.status.data;
});

/**
 * 単位付きの値をi18nで変換する
 * @param value - 値
 * @param unit - 単位
 * @param needConvert - 値を単位に合わせて変換する必要があるか
 */
const convertNumberWithUnitToStringWithGuard = (value?: number, unit?: string, needConvert = false): string => {
  if (!value || !unit) return '--';
  const convertedValue = needConvert ? convertLeadTimeByUnit(value, unit) : value;
  if (['month', 'months'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:月');
  } else if (['week', 'weeks'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:週');
  } else if (['day', 'days'].includes(unit)) {
    return convertedValue + t('発注根拠モーダル:日');
  }
  return convertedValue.toString();
};

/**
 * undefinedガード付きのunixTime変換関数
 * @param date - unixTimeの日付情報(undefined許容)
 */
const convertToDisplayUnixTimeWithGuard = (date?: number) =>
  date ? DateService.convertIYearMonthDayToYYYYMMDDWithSlash(DateService.convertUnixTimeToIDate(date / 1000)) : '--';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState && !!_ctx.orderData && !!basisData.value,
    "back-button-label": _unref(t)('閉じる'),
    "modal-width": 1400,
    "is-disabled-next-button": "",
    "enable-outside-click": "",
    "no-description": "",
    onOnBack: closeModal
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('発注根拠詳細')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('発注作成日')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(convertToDisplayUnixTimeWithGuard(_ctx.orderData?.createdOrderDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('発注数量')), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(sourceOrderInfo.value?.initialOrderAmount?.addComma() ?? '--'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('希望納期')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(convertToDisplayUnixTimeWithGuard(sourceOrderInfo.value?.initialDesiredDeliveryDate)), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('標準在庫指数(min)')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(convertNumberWithUnitToStringWithGuard(
                basisData.value?.userAdjustedStdInventoryIndex.min,
                basisData.value?.userAdjustedStdInventoryIndex.option.unit
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('標準在庫指数(max)')), 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(convertNumberWithUnitToStringWithGuard(
                basisData.value?.userAdjustedStdInventoryIndex.max,
                basisData.value?.userAdjustedStdInventoryIndex.option.unit
              )), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('リードタイム')), 1),
            _createElementVNode("div", _hoisted_20, _toDisplayString(convertNumberWithUnitToStringWithGuard(basisData.value?.userAdjustedLeadTime.value, basisData.value?.userAdjustedLeadTime.unit, true)), 1)
          ])
        ]),
        _createVNode(OrderBasisDetailSection, {
          "basis-data": basisData.value,
          "source-order-id": _ctx.orderData?.orderId
        }, null, 8, ["basis-data", "source-order-id"])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label"]))
}
}

})